// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goal-preview-modal__body{display:grid;grid-column-gap:3.5rem;-webkit-column-gap:3.5rem;-moz-column-gap:3.5rem;column-gap:3.5rem;grid-row-gap:3rem;row-gap:3rem;width:910px;grid-template-columns:350px 525px}.goal-preview-modal .modal-close-icon{top:44px}@media (max-width:1199px){.goal-preview-modal__body{width:720px}}", ""]);
// Exports
module.exports = exports;
